import { render, staticRenderFns } from "./SideCard.vue?vue&type=template&id=1f7e4354"
import script from "./SideCard.vue?vue&type=script&lang=ts"
export * from "./SideCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports